import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_dashboard/showcase/tabs/")({
  component: TabsShowcaseIndex,
});

function TabsShowcaseIndex() {
  const navigate = useNavigate();

  useEffect(() => {
    const redirect = async () => {
      await navigate({ to: "/showcase/tabs/$tab", params: { tab: "one" } });
    };
    redirect();
  }, [navigate]);

  return (
    <Outlet />
  );
}
